module.exports = __webpack_public_path__ + "img/Water_2_M_Normal.639428cf.jpg";